// extracted by mini-css-extract-plugin
export default {"cta":"kH-z","disabled":"lH-z"};